import type { IMapWidgetStore } from '.';

export default (self: IMapWidgetStore) => ({
  get data() {
    return self.nodes.toJSON();
  },
  get node() {
    const nodes = Array.isArray(self.node_id) ? self.node_id : [self.node_id];
    return nodes.filter((nodeId) => Boolean(self.nodes.getById(nodeId))).map((nodeId) => self.nodes.getById(nodeId));
  }
});
